var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20.608,
  height: 20.608,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#072C54",
  strokeWidth: 1.204,
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.737 4.523 4.531 14.729M14.737 14.728 4.531 4.522"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20.608v20.608H0z"
})))));
export { SvgCloseIcon as ReactComponent };
export default "/_next/static/images/close-icon.svg";